<template>
  <div class="overlay__controls">
    <div class="controls__upper">
      <div class="controls__container">
        <div class="overlay__title">
          <span
            class="overlay__title__text"
            data-overlay-prevent-close="true"
            v-html="title"
            />
        </div>

        <slideshowController
          :focusOnMount="true"
          :enabled="true"
          :gtm="gtm + ' / close '"
          className="controls__close"
          label="Close overlay"
          svgName="icon__x--24--stroke.svg"
          svgClass="controls__link__svg--close"
          @action="$emit('close')"
          />
      </div>
    </div>

    <lowerControllers
      :gtm="gtm"
      :hasPreviousSlide="hasPreviousSlide"
      :hasNextSlide="hasNextSlide"
      @previous="$emit('previous')"
      @next="$emit('next')"
      />
  </div>
</template>

<script>
  import slideshowController from '../controllers/controller.vue';
  import lowerControllers from './controller-previous-next-overlay.vue';

  export default {

    components: {
      slideshowController,
      lowerControllers,
    },

    props: {
      isLoading: { type: Boolean, required: true },
      title: { type: String, required: true },
      gtm: { type: String, required: true },
      currentIndex: {type: Number, required: true },
      slideLength: {type: Number, required: true },
    },

    computed: {
      hasPreviousSlide() {
        return !this.isLoading && this.currentIndex > 0 ;
      },

      hasNextSlide() {
        return !this.isLoading && (this.currentIndex < this.slideLength - 1);
      },
    },
  };
</script>
